import { bookSeller } from '@app/router/paths'
import { useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

interface ISearchInput {
  className?: string
  placeholder?: string
}

function SearchInput({
  className,
  placeholder = '作品名・著者名で検索'
}: ISearchInput) {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const [query, setQuery] = useState(() =>
    searchParams.get('q')
      ? searchParams.get('q')
      : searchParams.get('tag')
      ? searchParams.get('tag')
      : ''
  )

  const [composing, setComposing] = useState<boolean>(false)

  return (
    <div className={`search-input flex ${className}`}>
      <input
        value={query ?? ''}
        onChange={(e) => setQuery(e.target.value)}
        onKeyUp={(e) => {
          if (composing) {
            return
          }
          if ((e.keyCode === 13 || e.key === 'Enter') && !composing) {
            query?.trim() && navigate(`${bookSeller.searchList}?q=${query}`)
          }
        }}
        placeholder={placeholder}
        className="input width-100"
        style={{ textAlign: 'center' }}
        enterKeyHint="go"
        onCompositionStart={() => {
          setComposing(true)
        }}
        onCompositionEnd={() => {
          setComposing(false)
        }}
      />
      <img
        onClick={() => {
          query?.trim() && navigate(`${bookSeller.searchList}?q=${query}`)
        }}
        src="/assets/svg/search-icon.svg"
        alt="search-icon"
        className="search-icon cursor-pointer"
      />
    </div>
  )
}

export default SearchInput
